import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from '@/store';
import i18n from '@/plugins/locale-config';
import moment from 'moment-timezone';
import * as Promise from 'bluebird';

window.Promise = Promise;
import InputOnlyNumbers from '@/directives/InputOnlyNumbers';

import 'normalize.css';
import 'bootstrap/scss/bootstrap-grid.scss';
import '@/assets/styles.scss';

moment.tz.setDefault('Europe/Helsinki');
Vue.config.productionTip = false;
Vue.use(InputOnlyNumbers);
Vue.mixin({
  data: function() {
    return {
      get appInternalLinkUrl() {
        return process.env.VUE_APP_INTERNAL_LINK_BASE;
      },
    };
  },
});
new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
}).$mount('#app');
